import { render, staticRenderFns } from "./BuyPage.vue?vue&type=template&id=45adb7ba&"
import script from "./BuyPage.vue?vue&type=script&lang=js&"
export * from "./BuyPage.vue?vue&type=script&lang=js&"
import style0 from "./BuyPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports